exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n\r\n/*.bc-item {\r\n    margin-right: 10px;\r\n    padding: 5px;\r\n    border: 1px solid;\r\n    background-color:  white;\r\n}\r\n*/\r\n", ""]);

// exports
